import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { fetchReviews } from "../lib/api";

export const Reviews = () => {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        fetchReviews().then(setReviews).catch(() => setReviews([]));
    }, []);

    const doubled = [...reviews, ...reviews];

    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className="relative py-24 md:py-32 bg-black overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12">
                <div className="flex items-end justify-between flex-wrap gap-6">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="h-px w-10 bg-[#7CFC00]" />
                            <span className="text-[#7CFC00] uppercase tracking-[0.3em] text-xs font-semibold">
                                Word On The Street
                            </span>
                        </div>
                        <h2
                            data-testid="reviews-title"
                            className="font-display text-5xl md:text-7xl text-white uppercase tracking-tight"
                        >
                            5-Star <span className="text-[#7CFC00] text-glow">Reviews</span>.
                            <br /> Receipts.
                        </h2>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="flex">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} size={22} className="text-[#7CFC00] fill-[#7CFC00]" />
                            ))}
                        </div>
                        <div className="text-zinc-300">
                            <span className="font-display text-3xl text-white">5.0</span>
                            <span className="text-zinc-500 text-sm ml-2">/ 200+ clients</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Marquee row */}
            <div className="relative">
                <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

                <div data-testid="reviews-marquee" className="flex gap-5 animate-marquee whitespace-nowrap">
                    {doubled.map((r, i) => (
                        <div
                            key={`${r.id}-${i}`}
                            data-testid={`review-${r.id}-${i}`}
                            className="flex-shrink-0 w-[340px] md:w-[420px] whitespace-normal bg-[#0a0a0a] border border-white/10 hover:border-[#7CFC00] transition-colors p-6 md:p-7"
                        >
                            <Quote size={28} className="text-[#7CFC00] mb-3" />
                            <p className="text-zinc-200 text-base md:text-lg leading-relaxed font-script">
                                "{r.quote}"
                            </p>
                            <div className="mt-5 pt-5 border-t border-white/10 flex items-center justify-between">
                                <div>
                                    <div className="font-display text-lg text-white tracking-wide">
                                        {r.name}
                                    </div>
                                    {r.location && (
                                        <div className="text-xs text-zinc-500 uppercase tracking-widest">
                                            {r.location}
                                        </div>
                                    )}
                                </div>
                                <div className="flex">
                                    {[...Array(r.rating)].map((_, k) => (
                                        <Star
                                            key={k}
                                            size={14}
                                            className="text-[#7CFC00] fill-[#7CFC00]"
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
